import { isTypeContentNavigation } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulContentNavigation = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeContentNavigation(entry)) {
    return null;
  }

  return <div>ContentfulContentNavigation</div>;
};

export default ContentfulContentNavigation;
